export default "__VITE_ASSET__Hnxmw6M$__"